export enum ClientTypeEnum {
  All = 0,
  WebClient = 1,
  MobileClient = 2,
}

export enum ClientPlatformEnum {
  Windows = "Windows",
  Macintosh = "Macintosh",
}
